(function () {
    var root = document.querySelector('[data-nq-cd]');
    if (!root || root.dataset.nqCdBound === '1') return;
    root.dataset.nqCdBound = '1';

    var panel = root.querySelector('[data-nq-cd-panel]');
    var lastFocus = null;
    var AUTO_OPEN = true;

    function contentsNode() { return root.querySelector('[data-nq-cd-contents]'); }

    function openDrawer() {
      lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nq-cd-open');
      startReserveTimer();
      tickReserve();
      setTimeout(function () { var c = root.querySelector('[data-nq-cd-close]'); if (c) c.focus(); }, 60);
    }
    function closeDrawer() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nq-cd-open');
      stopReserveTimer();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* ── reservation countdown: 10:00 → 00:00, persists via sessionStorage across drawer
       opens AND contents swaps (the timer node is re-rendered, so we re-query each tick).
       At 00:00 it restarts at 10:00 to keep the reservation alive. ── */
    var RESERVE_MS = 10 * 60 * 1000;
    var reserveTimer = null;
    function startReserveTimer() {
      if (reserveTimer) return;
      reserveTimer = setInterval(tickReserve, 1000);
    }
    function stopReserveTimer() {
      if (!reserveTimer) return;
      clearInterval(reserveTimer);
      reserveTimer = null;
    }
    function reserveDeadline() {
      var d = parseInt(sessionStorage.getItem('nqCdReserve'), 10);
      if (!d || isNaN(d) || d - Date.now() > RESERVE_MS) { d = Date.now() + RESERVE_MS; sessionStorage.setItem('nqCdReserve', d); }
      return d;
    }
    function tickReserve() {
      var rem = reserveDeadline() - Date.now();
      if (rem <= 0) { var nd = Date.now() + RESERVE_MS; sessionStorage.setItem('nqCdReserve', nd); rem = RESERVE_MS; }
      var m = Math.floor(rem / 60000), s = Math.floor((rem % 60000) / 1000);
      var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      document.querySelectorAll('[data-nq-cd-timer]').forEach(function (el) { el.textContent = txt; });
    }
    reserveDeadline(); tickReserve();

    /* ── Section Rendering API: swap only [data-nq-cd-contents]; shell + open state persist ── */
    function applySection(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-nq-cd-contents]');
      var current = contentsNode();
      if (fresh && current) {
        current.className = fresh.className;
        current.innerHTML = fresh.innerHTML;
      }
      syncHeaderCount(doc);
    }
    function syncHeaderCount(doc) {
      var src = (doc || document).querySelector('[data-nq-cd-count]');
      var n = src ? src.textContent.trim() : null;
      if (n === null) return;
      document.querySelectorAll('[data-nq-header] [data-nq-cart-count]').forEach(function (el) {
        el.textContent = n;
        if (n === '0' || n === '') el.setAttribute('hidden', '');
        else el.removeAttribute('hidden');
      });
    }
    function refresh() {
      return fetch('/?sections=nq-cart-drawer', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { applySection(j['nq-cart-drawer']); })
        .catch(function () {});
    }

    /* Serialize cart mutations so rapid clicks never race Shopify's cart.
       The optimistic DOM update (in the click handler) makes it feel instant;
       the actual /cart/change.js calls queue behind each other here. */
    var cartChain = Promise.resolve();
    function postCart(url, body) {
      body.sections = 'nq-cart-drawer';
      body.sections_url = '/';
      cartChain = cartChain.then(function () {
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (j) {
          if (j.sections) applySection(j.sections['nq-cart-drawer']);
          else refresh();
          return j;
        }).catch(function () { refresh(); });
      });
      return cartChain;
    }

    /* ── delegated controls (panel persists, so binding survives swaps) ── */
    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('button, a');
      if (!btn) return;

      if (btn.hasAttribute('data-nq-cd-close')) { e.preventDefault(); closeDrawer(); return; }

      if (btn.hasAttribute('data-nq-cd-qty')) {
        var key = btn.getAttribute('data-nq-cd-qty');
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        var q = btn.parentNode.querySelector('.q');
        var current = q ? parseInt(q.textContent, 10) : 1;
        var next = Math.max(0, current + delta);
        if (q) q.textContent = next;                                 /* optimistic: number updates instantly */
        var qItem = btn.closest('.nq-cd__item');
        if (next === 0 && qItem) { qItem.style.opacity = '0.4'; qItem.style.pointerEvents = 'none'; }
        postCart('/cart/change.js', { id: key, quantity: next });
        return;
      }
      if (btn.hasAttribute('data-nq-cd-remove')) {
        var rItem = btn.closest('.nq-cd__item');
        if (rItem) { rItem.style.opacity = '0.4'; rItem.style.pointerEvents = 'none'; }  /* optimistic: item fades out instantly */
        postCart('/cart/change.js', { id: btn.getAttribute('data-nq-cd-remove'), quantity: 0 });
        return;
      }
      if (btn.hasAttribute('data-nq-cd-add') && !btn.disabled) {
        var vid = btn.getAttribute('data-nq-cd-add');
        btn.disabled = true;
        var addItem = { id: vid, quantity: 1 };
        var uSlot = btn.getAttribute('data-nq-slot'), uAnchor = btn.getAttribute('data-nq-anchor');
        if (uSlot || uAnchor) { addItem.properties = { '_upsell_src': 'cart|' + (uSlot || '') + '|' + (uAnchor || ''), '_upsell_v': 'v1' }; }
        postCart('/cart/add.js', { items: [ addItem ] });
        return;
      }
    });

    /* close on scrim / Esc + basic focus trap */
    root.addEventListener('click', function (e) {
      if (e.target.classList && e.target.classList.contains('nq-cd__scrim')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('button:not([disabled]), [href], input:not([hidden]), select, textarea:not([hidden]), [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });

    /* header cart icon → open drawer */
    document.addEventListener('nq-cart:open', openDrawer);

    /* Product PDP + gift-box ATC buttons add via /cart/add.js then dispatch `cart:build` (an
       UpCart-era convention). Our own drawer previously ignored it, so items were added silently
       without the drawer ever opening. Wire it here once, covering all 7 product sections: on
       cart:build, refresh the drawer section then open it. */
    document.addEventListener('cart:build', function () {
      refresh().then(function () { if (AUTO_OPEN) openDrawer(); });
    });

    /* auto-open after add-to-cart (capture-phase; stops other submit handlers to avoid double-add) */
    if (AUTO_OPEN) {
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
        if (form.hasAttribute('data-nq-cd-skip')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var fd = new FormData(form);
        fd.append('sections', 'nq-cart-drawer');
        fd.append('sections_url', '/');
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (j.sections) applySection(j.sections['nq-cart-drawer']); else refresh();
            openDrawer();
          })
          .catch(function () { form.submit(); });
      }, true);
    }

    window.nqCart = { open: openDrawer, close: closeDrawer, refresh: refresh };
  })();
